<template>
  <a-tabs v-model="activeKey">
    <a-tab-pane v-for="(pane,i) in list" :key="i+1" :tab="pane.title">
      <a-alert v-if="!alert" :message="msg(pane)" type="info" show-icon style="margin-bottom: 10px;"/>
      <Table :columns="columns" :list="pane.details" />
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import Table from './Table.vue';
export default {
  components: {Table},
  props: ['columns','list','len','alert'],
  data() {
    return {
      activeKey: 1,
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    msg(pane){
      return <p class='alertMsg margBm'>
          吃食鱼合计: <span class='alertNum'>{pane.csNum}尾({pane.csWeight || 0}斤) </span> 
          滤食鱼合计: <span class='alertNum'>{pane.lsNum}尾({pane.lsWeight || 0}斤)</span> 
        </p>
    },
  },
}
</script>
<style lang='scss' scoped>
.alertMsg{
  font-size: 12px;
}
.alertNum{
  font-size: 14px;
}
</style>